import { Box, BoxProps } from "@chakra-ui/react";

export const Panel: React.FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box bg="white" borderRadius="lg" shadow="sm" {...props}>
      {children}
    </Box>
  );
};
